import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import logoImage from '../../../../assets/common/logo.svg';
import { validateProps } from '../../../../utils/propValidator';

const propRules = {
  orientation: { oneOf: ['horizontal', 'vertical'] },
  size: { oneOf: ['sm', 'md', 'lg'] },
  showTagline: { type: 'boolean' },
};

/**
 * AppLogo component
 *
 * @component
 * @name AppLogo
 * @param {Object} props - component props
 * @param {'horizontal' | 'vertical'} [props.orientation] - logo orientation
 * @param {'sm', 'md', 'lg'} [props.size] - logo size
 * @param {boolean} [props.showTagline] - conditional tagline display
 * @returns {React.ReactElement}
 *
 */
export default function AppLogo(props: any) {
  validateProps(props as Record<string, unknown>, propRules, 'AppLogo');
  const { orientation = 'horizontal', size = 'medium', showTagline = false } = props;

  const imageSize = { sm: 48, md: showTagline ? 64 : 48, lg: 200 }[size];
  const companyFontSize = { sm: '1rem', md: '1.375rem', lg: '2.25rem' }[size];
  const subTextFontSize = { sm: '0.75rem', md: '0.875rem', lg: '1.75rem' }[size];
  const taglineFontSize = { sm: '0.65rem', md: '0.75rem', lg: '1.25rem' }[size];

  const isVertical = orientation === 'vertical';

  return (
    <Stack direction={isVertical ? 'column' : 'row'} alignItems='center' gap={1}>
      <Box
        component='img'
        alt=''
        src={logoImage}
        sx={{ height: imageSize, width: imageSize, objectFit: 'contain' }}
      />
      <Stack textAlign={isVertical ? 'center' : 'left'}>
        <Typography
          fontSize={companyFontSize}
          lineHeight={1.15}
          fontWeight={700}
          color='logo.main'
          variant='logo'
        >
          Structualtants
        </Typography>
        <Typography fontSize={subTextFontSize} lineHeight={1.15} color='logo.main' variant='logo'>
          Designs LLP
        </Typography>
        {showTagline && (
          <Typography
            color='logo.main'
            variant='logoTagline'
            fontSize={taglineFontSize}
            fontWeight={300}
            mt={0.5}
            letterSpacing={1.6}
          >
            We make it simple.
          </Typography>
        )}
      </Stack>
    </Stack>
  );
}
